import { Phone, Mail, MapPin, Navigation } from "lucide-react";
import { Container, Reveal, PageHero } from "../components/site/Primitives";
import { CONTACT, IMG } from "../data/site";
import { WhatsAppIcon } from "../components/site/WhatsAppIcon";

const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(CONTACT.mapQuery)}&z=14&output=embed`;
const dirHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.mapQuery)}`;

const Block = ({ icon: Icon, title, children, testId }) => (
  <div data-testid={testId} className="border-t border-slate-200 py-8 first:border-t-0 first:pt-0">
    <div className="flex items-center gap-3"><Icon className="h-5 w-5 text-brand" /><p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">{title}</p></div>
    <div className="mt-4">{children}</div>
  </div>
);

const rowCls = "group flex items-center justify-between gap-4 py-2 font-display text-xl sm:text-2xl font-medium text-ink hover:text-brand transition-colors";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero testId="contact-hero" eyebrow="Get in touch" title="Contact us" img={IMG("about_gallery-material-handling")} lead="Reach our commercial and technical teams by phone, email, or WhatsApp. We serve customers across India and export markets." />
      <section className="py-24 lg:py-28">
        <Container className="grid gap-14 lg:grid-cols-[1fr_1.1fr] lg:gap-20">
          <Reveal>
            <Block icon={Phone} title="Phone" testId="contact-phones">
              {CONTACT.phones.map((p, i) => <a key={p.tel} href={`tel:${p.tel}`} data-testid={`contact-phone-${i}`} className={rowCls}>{p.label}<Phone className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" /></a>)}
            </Block>
            <Block icon={Mail} title="Email" testId="contact-emails">
              {CONTACT.emails.map((e, i) => <a key={e} href={`mailto:${e}`} data-testid={`contact-email-${i}`} className={`${rowCls} break-all text-lg sm:text-xl`}>{e}</a>)}
            </Block>
            <Block icon={MapPin} title="Address" testId="contact-address">
              <address className="not-italic text-lg leading-relaxed text-slate-700">{CONTACT.address.map((l) => <span key={l} className="block">{l}</span>)}</address>
            </Block>
            <div className="mt-4 flex flex-wrap gap-3">
              <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-button" className="btn bg-[#128C7E] text-white hover:brightness-95"><WhatsAppIcon className="h-4 w-4" /> WhatsApp +91 98509 95074</a>
              <a href={`tel:${CONTACT.phones[0].tel}`} data-testid="contact-call-button" className="btn bg-navy text-white hover:bg-navy-800"><Phone className="h-4 w-4" /> Call now</a>
              <a href={dirHref} target="_blank" rel="noreferrer" data-testid="contact-directions-button" className="btn border border-navy/25 text-navy hover:bg-navy hover:text-white"><Navigation className="h-4 w-4" /> Directions</a>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="relative h-full min-h-[420px] border border-slate-200 bg-mist" data-testid="contact-map">
              <iframe title="MU Plast location" src={mapSrc} className="absolute inset-0 h-full w-full grayscale-[30%]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </Reveal>
        </Container>
      </section>
    </div>
  );
}
